module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_setup3-981a4eaf.png";